


import TiwiMixin from '../mixins/TiwiMixin';

export default {
  mixins: [TiwiMixin],
  props: {
    review: {
      default: {}
    },
  },
  data() {
    return {

    }
  },
  mounted: function () {

  },
  methods: {

  },
}
